import { Box, Grid, Typography } from "@mui/material";
import {
  servicesComplementarySports,
  servicesMedicalSports,
  servicesVirtualSports,
} from "../options";

const FooterProposal = ({ brand }) => {
  return (
    <Box width={"100%"} py={{ xs: 2, md: 6 }} px={{ xs: 3, md: 12 }}>
      <Box display={"flex"} justifyContent={"center"}>
        <Typography variant="h5" color="#626160" fontSize={"16px"}>
          Afiliándote en {brand.name} obtienes
        </Typography>
      </Box>
      <Grid py={{ xs: 2, md: 6 }} container>
        <Grid xs={4}>
          <Box
            border={`1px ${brand.color} solid`}
            boxShadow={"0px 2px 4px 0px #78605633"}
            borderRadius={"12px"}
            padding={"10px 25px"}
          >
            <Box display={"flex"} justifyContent={"center"}>
              <Typography variant="h5" color="#969595" fontSize={"12px"}>
                Servicios médicos deportivos
              </Typography>
            </Box>
            <Box
              display={"flex"}
              justifyContent={"center"}
              flexWrap="wrap"
              overflow="hidden"
            >
              {servicesMedicalSports(brand).map((item) => {
                return (
                  <Box
                    margin={"10px 6px 0 0"}
                    maxWidth={"64px"}
                    display={"flex"}
                    flexDirection={"column"}
                    alignItems={"center"}
                  >
                    {item.icon}
                    <Typography fontSize={"8px"} textAlign={"center"}>
                      {item.text}
                    </Typography>
                  </Box>
                );
              })}
            </Box>
          </Box>
        </Grid>
        <Grid xs={4} padding={"0 10px"}>
          <Box
            border={`1px ${brand.color} solid`}
            boxShadow={"0px 2px 4px 0px #78605633"}
            borderRadius={"12px"}
            padding={"10px 25px"}
          >
            <Box display={"flex"} justifyContent={"center"}>
              <Typography variant="h5" color="#969595" fontSize={"12px"}>
                Servicios médicos complementarios
              </Typography>
            </Box>
            <Box
              display={"flex"}
              justifyContent={"space-around"}
              flexWrap="wrap"
              overflow="hidden"
            >
              {servicesComplementarySports(brand).map((item) => {
                return (
                  <Box
                    margin={"10px 6px 0 0"}
                    maxWidth={"64px"}
                    display={"flex"}
                    flexDirection={"column"}
                    alignItems={"center"}
                  >
                    {item.icon}
                    <Typography fontSize={"8px"} textAlign={"center"}>
                      {item.text}
                    </Typography>
                  </Box>
                );
              })}
            </Box>
          </Box>
        </Grid>
        <Grid xs={4}>
          <Box
            border={`1px ${brand.color} solid`}
            boxShadow={"0px 2px 4px 0px #78605633"}
            borderRadius={"12px"}
            padding={"10px 25px"}
          >
            <Box display={"flex"} justifyContent={"center"}>
              <Typography variant="h5" color="#969595" fontSize={"12px"}>
                Servicios virtuales
              </Typography>
            </Box>
            <Box
              display={"flex"}
              justifyContent={"space-around"}
              flexWrap="wrap"
              overflow="hidden"
            >
              {servicesVirtualSports(brand).map((item) => {
                return (
                  <Box
                    margin={"10px 6px 0 0"}
                    maxWidth={"64px"}
                    display={"flex"}
                    flexDirection={"column"}
                    alignItems={"center"}
                  >
                    {item.icon}
                    <Typography fontSize={"8px"} textAlign={"center"}>
                      {item.text}
                    </Typography>
                  </Box>
                );
              })}
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default FooterProposal;
